// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TrustedClients from "./components/TrustedClients";
import CtaDevis from "./components/CtaDevis";

// Pages
import Home from "./pages/Home";
import Galerie from "./pages/Galerie";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AccesClientsMH from "./pages/AccesClientsMH"; // ⬅️ NEW

// Styles
import "./index.css";

export default function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* Navigation */}
        <Navbar />

        {/* Contenu principal */}
        <main className="flex-grow">
          <Routes>
            {/* Accueil -> Galerie */}
            <Route path="/" element={<Home />} />

            {/* Pages principales */}
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Accès clients (maximeh.lu) */}
            <Route path="/acces-clients" element={<AccesClientsMH />} />

            {/* 404 simple */}
            <Route path="*" element={<Navigate to="/galerie" replace />} />
          </Routes>
        </main>

        {/* CTA devis flottant */}
        <CtaDevis />

        {/* Bandeau logos clients */}
        <TrustedClients />

        {/* Pied de page */}
        <Footer />
      </div>
    </Router>
  );
}